<template>
  <div
    ref="advance_filter"
    id="advance_filter"
    class="modal modal-right fade modal-more-filters"
    tabindex="-1"
    role="dialog"
    aria-labelledby="advance_filter"
  >
    <div
      class="modal-dialog"
      role="document"
      style="width: 360px;"
    >
      <div
        class="modal-content"
        ref="section"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("More Filters") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('status')"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-status"
              >
                <div>{{ $t("Order Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': !options.status}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{'mb-0': !statusList.length}"
                >
                  <div
                    class="form-check"
                    v-for="status in statusList"
                    :key="status.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-checker">
                        <span :class="{'checked' : dataFilter.status.includes(status.id)}">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="status.id"
                            :id="'status-'+status.id"
                            v-model="dataFilter.status"
                            @change="filterChange()"
                          >
                        </span>
                      </div>
                      {{ $t(status.name) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('status')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>
  
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('payment_method')"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-payment_method"
              >
                <div>{{ $t("Payment Methods") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': !options.payment_method}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-payment_method"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{'mb-0': !datainfo.payment_method.length}"
                >
                  <div
                    class="form-check"
                    v-for="payment in datainfo.payment_method"
                    :key="payment.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span :class="[(dataFilter.payment_method === payment.id ? 'checked' : '')]">
                          <input
                            type="radio"
                            :value="payment.id"
                            :id="payment.id"
                            v-model="dataFilter.payment_method"
                            @change="filterChange()"
                          >
                        </span>
                      </div>
                      <!-- <img
                        :src="$storeIndex.getImageSrc('payment/report/'+payment.name.toLowerCase(), '.png')"
                        class="image_box"
                      > -->
                      {{ $t(payment.name) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('payment_method')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>
  
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('payment_status')"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-payment_status"
              >
                <div>{{ $t("Payment Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': !options.payment_status}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-payment_status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{'mb-0': !datainfo.payment_status.length}"
                >
                  <div
                    class="form-check"
                    v-for="payment in datainfo.payment_status"
                    :key="payment.id"
                  >
                    <label 
                      v-if="(
                        (!dataFilter.status.length || (dataFilter.status.length && payment.order_status.filter(status => dataFilter.status.includes(status)).length)) &&
                        (
                          Array.isArray(dataFilter.payment_method) ||
                          (payment.cod_method && payment.other_method) ||
                          (payment.cod_method && !payment.other_method && datainfo.payment_method_group[dataFilter.payment_method] == 2) ||
                          (payment.other_method && !payment.cod_method && datainfo.payment_method_group[dataFilter.payment_method] != 2)
                        )
                      )"
                      class="form-check-label"
                    >
                      <div class="uniform-choice">
                        <span :class="[(dataFilter.payment_status === payment.id ? 'checked' : '')]">
                          <input
                            type="radio"
                            :value="payment.id"
                            :id="payment.id"
                            v-model="dataFilter.payment_status"
                            @change="filterChange()"
                          >
                        </span>
                      </div>
                      {{ $t(payment.name) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('payment_status')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
          <button
            type="button"
            class="btn btn-light"
            @click="clearFilter('all')"
          >
            {{ $t('Clear all filters') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="doneFilter()"
            data-dismiss="modal"
          >
            {{ $t('Done') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import Api from '@/services/endpoint/tenant.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import moment from "moment";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import Axios from 'axios';
  import Select2 from "v-select2-component";
  
  export default {
      name: "AdvanceFilter",
      components: {
          DateRangePicker,
          moment,
          Select2
      },
      props: ["filter", "carrierList", "statusList", "status", "carrier", "payment_method", "payment_status", "channels", "dateRange"],
      data() {
          let vm = this;
          return {
              options: {
                  status: false,
                  carrier: false,
                  payment_method: false,
                  payment_status: false,
                  channels: false,
                  date: false,
                  tag: false,
              },
              dataFilter: initialFilter(),
              datainfo: {
                  payment_method_group: {},
                  payment_method: [],
                  payment_status: [
                      {
                          'id': '1',
                          'name': this.$t('_Payment.Pending'),
                          'order_status': ['pending', 'processing', 'returned'],
                          'cod_method': true,
                          'other_method': true,
                      },
                      {
                          'id': '2',
                          'name': this.$t('Partial Paid'),
                          'order_status': ['pending'],
                          'cod_method': false,
                          'other_method': true,
                      },
                      {
                          'id': '3',
                          'name': this.$t('Paid'),
                          'order_status': ['pending'],
                          'cod_method': false,
                          'other_method': true,
                      },
                      {
                          'id': '4',
                          'name': this.$t('Confirmed'),
                          'order_status': ['processing', 'completed', 'returned'],
                          'cod_method': true,
                          'other_method': true,
                      },
                      {
                          'id': '5',
                          'name': this.$t('Canceled'),
                          'order_status': ['returned', 'canceled'],
                          'cod_method': true,
                          'other_method': false,
                      },
                  ],
                  channels: [],
                  date: {
                      singleDatePicker: 'range',
                      opens: 'right',
                      ranges: true,
                      appendtobody: true,
                      autoApply: true,
                      localedata: {
                          format: 'dd/mm/yyyy',
                      }
                  },
              },
              tags: [],
              newTags: [],
              option: [],
              settingOption:{
                  minimumResultsForSearch: Infinity,
                  multiple: true,
                  tags: false,
                  templateResult: this.templateCustom,
                  templateSelection: this.templateSelect,
                  maximumSelectionLength: 5,
                  language: {
                      maximumSelected: function (e) {
                          // e.maximum != 1 && (text += "s");
                          var text = vm.$t('_Tags.You can only select')+ ' ' + e.maximum + ' ' + vm.$t('_Tags.items');
                          // var text = vm.$t('Enter tags...')
                          
                          return text;
                      },
                      // searching:function (e) {
                      //     var text = vm.$t('Searching...');   
                      //     return text;
                      // },
                      loadingMore:function (e) {
                          return '<i class="fa fa-spinner fa-spin"></i>';
                      },
                  },
                  // dropdownParent : "#tags-search",
                  dropdownCssClass: 'tags-layout',
                  ajax: {
                      cache: true,
                      delay: 250,
                      beforeSend: function (request) {
                          request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
                      },
                      url: Api.AUTH.URL + Api.URL.TAG + '?module_name=Order',
                      // ?search=[term]&page=[page]
                      
                      data: function (params) {
                          var query = {
                              q: params.term,
                              page: params.page || 1
                          }
                          // console.log(query,'params.page');
                          return query;
                      },
                      processResults: function (data, params) {
                          let option = data.data;
                          let pageCurrent = data.meta.current_page
                          option = option.map( function(item) {    
                              return{
                                  id: item.name,
                                  text: item.name,
                                  color: item.color,
                                  ctid: item.id,
                              }
                          })
  
                          return {
                              results: option,
                              pagination: {
                                  more: (pageCurrent * 10) < data.meta.total
                              }
                          };
                      }   
                  },
              },
          }
      },
      async mounted() {
          this.getPayment();
          this.getChannels();
          $(this.$refs.advance_filter).on('shown.bs.modal', () => {
          });
          // this.getOptions();
      },
      created() {
        this.dataFilter.status = this.$parent.paramsQuery.status;
      },
      computed: {
          showTextPicker: function () {
              if (this.dataFilter.dateRange.startDate && this.dataFilter.dateRange.endDate) {
                  return moment(this.dataFilter.dateRange.startDate).utc().format('DD/MM/YYYY') + ' - ' + moment(this.dataFilter.dateRange.endDate).utc().format('DD/MM/YYYY');
              } else {
                  return this.$t("Order Date...");
              }
          }
      },
      methods: {
          toggleOption(key) {
              if (key == 'status') {
                  (this.options.status) ? this.options.status = false: this.options.status = true;
              } else if (key == 'carrier') {
                  (this.options.carrier) ? this.options.carrier = false: this.options.carrier = true;
              } else if (key == 'payment_method') {
                  (this.options.payment_method) ? this.options.payment_method = false: this.options.payment_method = true;
              } else if (key == 'payment_status') {
                  (this.options.payment_status) ? this.options.payment_status = false: this.options.payment_status = true;
              } else if (key == 'channels') {
                  (this.options.channels) ? this.options.channels = false: this.options.channels = true;
              } else if (key == 'date') {
                  (this.options.date) ? this.options.date = false: this.options.date = true;
              } else if (key == 'tag') {
                  (this.options.tag) ? this.options.tag = false: this.options.tag = true;
              }
          },
          clearFilter(key) {
              if (key == 'status') {
                  this.dataFilter.status = [];
              } else if (key == 'carrier') {
                  this.dataFilter.carrier = [];
              } else if (key == 'payment_method') {
                  this.dataFilter.payment_method = [];
              } else if (key == 'payment_status') {
                  this.dataFilter.payment_status = [];
              } else if (key == 'channels') {
                  this.dataFilter.channels = [];
              } else if (key == 'date') {
                  this.dataFilter.dateRange.startDate = null;
                  this.dataFilter.dateRange.endDate = null;
              } else if (key == 'tag') {
                  this.dataFilter.tag = '';
              } else if (key == 'all') {
                  this.dataFilter = initialFilter();
                  // this.dataFilter.status = [];
                  // this.dataFilter.carrier = [];
                  // this.dataFilter.payment_method = [];
                  // this.dataFilter.payment_status = [];
                  // this.dataFilter.channels = [];
                  // this.dataFilter.dateRange.startDate = null;
                  // this.dataFilter.dateRange.endDate = null;
                  // this.$parent.countFilter = 0;
              }
          },
          async getPayment(){
            let data = await Api.PaymentMethod.getPaymentMethod()
            //this.datainfo.payment_method.pop(); //removes the last element from an array
            const dataLits = data.data.data;
            if (dataLits != undefined) {
                let mapped = dataLits.reduce((el, obj) => {
                 let found = el.find(x => x.name === obj.name);
                 if (found) {
                 found.id = `${found.id},${obj.id}`;
                 } else {
                 el.push(obj);
                 }
                 return el;
             }, []);
             this.datainfo.payment_method_group = mapped.reduce((group, payment) => ({...group, ...{ [payment.id]: payment.payment_method_group_id }}), {});
             this.datainfo.payment_method = mapped;
             this.$emit('payment_method', this.datainfo.payment_method);
            }
          },
          async getChannels(){
            let data = await Api.Integration.getIntegration('?integration_group_id=1')
            this.datainfo.channels = data.data.data;
            this.$emit('channel', data.data.data);
          },
          filterChange() {
            if (!Array.isArray(this.dataFilter.payment_status)) {
              const payment = this.datainfo.payment_status.find(payment => payment.id == this.dataFilter.payment_status);
              if (this.dataFilter.status.length) {
                if (!payment.order_status.filter(status => this.dataFilter.status.includes(status)).length) {
                  this.dataFilter.payment_status = [];
                }
              }
              if (!Array.isArray(this.dataFilter.payment_method) && (!payment.cod_method || !payment.other_method)) {
                if (
                  (payment.cod_method && !payment.other_method && this.datainfo.payment_method_group[this.dataFilter.payment_method] != 2) ||
                  (payment.other_method && !payment.cod_method && this.datainfo.payment_method_group[this.dataFilter.payment_method] == 2)
                ) {
                  this.dataFilter.payment_status = [];
                }
              }
            }
          },
          doneFilter() {
                this.$parent.countFilter = 0;
                if(this.dataFilter.status.length > 0){
                    this.$parent.countFilter += 1;
                }
                if(this.dataFilter.payment_method > 0 || this.dataFilter.payment_method != ''){
                    this.$parent.countFilter += 1;
                }
                if(this.dataFilter.payment_status > 0){
                    this.$parent.countFilter += 1;
                }
                if(this.dataFilter.channels > 0){
                    this.$parent.countFilter += 1;
                }
              this.$parent.filterinfo(this.dataFilter);
          },
          myChangeEvent(val){
              // console.log(val);
          },
          mySelectEvent({id, text , color, name}){
              // console.log({id, text, color, name});
          },
          
          templateCustom: function (option) {
  
              if (!option.id) {
                  return $(`<div class="loading-small p-0" style="z-index:9999; height:0;"></div>`);
              }else{
  
                  if (!option.name) {
                      option.name = option.text;
                      if(!option.color){
                          option.color = '#26ADCA';
                      }   
                  }
                  let optionName = option.name;
                  let colorTags = option.color;
                  let txt = $(`<div class='list-item d-flex templatecustom'><div class='item-icon'><i class="fa-1x fa-solid fa-tag mr-1 position-relative top" style="color:${colorTags};top: 2px;"></i></div><div class='item-content'><div class='item-name'>${optionName}</div></div></div>`);
                  return txt;  
              }  
          },
          templateSelect: function (option) {
              if (!option.name) {
                  option.name = option.text;
                  option.color = '#26ADCA';
              }
  
              let optionName = option.name;
              let colorTags = option.color;
              let txt = $(`<div class='list-item d-flex templateselect' style="background:${colorTags};"><div class='item-icon' style='color:#fff;'><i class="fa-solid fa-tag mr-1"></i></div><div class='item-content'><div class='item-name' style='color:#fff;'>${optionName}</div></div></div>`);
              return txt;    
          },
          
      }
  }
  
  function initialFilter() {
      return {
          status: [],
          carrier: [],
          payment_method: [],
          payment_status: [],
          channels: [],
          dateRange: {
              startDate: null,
              endDate: null,
          },
          tag:[],
  
      }
  }
  </script>

<style scoped>
    .image_box{
        margin: -5px 5px 0 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/saledaily/AdvanceFilterSaleDaily.vue